module.exports = __webpack_public_path__ + "static/img/Facia_Steel.8325801.jpg";